/* istanbul ignore file */
import { SecurityContextCommonProps, SecurityContextTemplate } from 'framework/authorization';
import useAccountManagementService from './useAccountManagementService';
import { DELIVERY_CONTEXT } from './model';

const DeliveryContext = ({ permissionToCheck = null, children }: SecurityContextCommonProps) => {
  const { getGlobalDeliveryPermissions } = useAccountManagementService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={(id: string) => getGlobalDeliveryPermissions(id)}
      permissionToCheck={permissionToCheck}
      contextName={DELIVERY_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default DeliveryContext;
